import { FIRST_INDEX, MODAL_STORE_OPEN_TIMEOUT, MODAL_STORE_HIGHLIGHT_TIMEOUT, DOWNLOAD_CONFIGS } from "../constants";
import {
  getReconciliationRunLog,
  GetSFMDisplay,
  RollbackReconciliationRun,
} from "@helpers/helpers";
import { pollReconciliationFile } from "@helpers/apiHelper";
import InfoModalStore from "@stores/InfoModalStore";
import DownloadModalStore from "@stores/DownloadModalStore";
import SfmModalStore from "@stores/SfmModalStore";
import myStore from "../store";

export const buildActions = (translate) => {

  return {
    VIEW_DETAILS: {
      actionTypeTag: "VIEW_DETAILS",
      name: translate("reconciliation-runs.actions.VIEW_DETAILS"),
      actionFN: (row) => {
        getReconciliationRunLog({
          ReconciliationRunId: row.original.ReconciliationRunId,
          callback: (data) => {
            if (data.ReconciliationRunLog) {
              InfoModalStore.open({
                type: "Reconciliation_Run_Info",
                title: translate(
                  "reconciliation-runs.titles.RECONCILIATION_RUN_INFO"
                ),
                data: data.ReconciliationRunLog,
                show: true,
              });
            } else {
              const sfmData = GetSFMDisplay(data.SFM);
              SfmModalStore.open({
                DetailedMessage: translate("shared.no-details-message"),
                Message: "SUCCESS",
                SfmTag: "SFM_SUCCESS",
                Type: 1,
                ShowMessage: true,
              });
            }
          },
          store: myStore,
        });
      },
      confirmation: false,
    },
    DOWNLOAD_MATCHING_RESULTS: {
      actionTypeTag: "DOWNLOAD_MATCHING_RESULTS",
      name: translate("reconciliation-runs.actions.DOWNLOAD_MATCHING_RESULTS"),
      actionFN: (row) => {
        pollReconciliationFile(
          myStore,
          translate,
          "GetReconciliationFile",
          (data) => data.Files[FIRST_INDEX],
          (data, newPendingID) => {
            DownloadModalStore.open(MODAL_STORE_OPEN_TIMEOUT);
            DownloadModalStore.highlight(
              MODAL_STORE_HIGHLIGHT_TIMEOUT,
              newPendingID
            );
          },
          DOWNLOAD_CONFIGS.MATCHING_RESULTS.domain,
          DOWNLOAD_CONFIGS.MATCHING_RESULTS.type,
          "ReconciliationRunId",
          row.original.ReconciliationRunId.toString(),
          DOWNLOAD_CONFIGS.MATCHING_RESULTS.label
        );
      },
      confirmationMessage: translate(
        "reconciliation-runs.confirmation-messages.DOWNLOAD_MATCHING_RESULTS"
      ),
      confirmation: true,
    },
    DOWNLOAD_ROLLBACK_RESULTS: {
      actionTypeTag: "DOWNLOAD_ROLLBACK_RESULTS",
      name: translate("reconciliation-runs.actions.DOWNLOAD_ROLLBACK_RESULTS"),
      actionFN: (row) => {
        pollReconciliationFile(
          myStore,
          translate,
          "GetReconciliationFile",
          (data) => data.Files[FIRST_INDEX],
          (data, newPendingID) => {
            DownloadModalStore.open(MODAL_STORE_OPEN_TIMEOUT);
            DownloadModalStore.highlight(
              MODAL_STORE_HIGHLIGHT_TIMEOUT,
              newPendingID
            );
          },
          DOWNLOAD_CONFIGS.ROLLBACK_RESULTS.domain,
          DOWNLOAD_CONFIGS.ROLLBACK_RESULTS.type,
          "ReconciliationRunId",
          row.original.ReconciliationRunId.toString(),
          DOWNLOAD_CONFIGS.ROLLBACK_RESULTS.label
        );
      },
      confirmationMessage: translate(
        "reconciliation-runs.confirmation-messages.DOWNLOAD_ROLLBACK_RESULTS"
      ),
      confirmation: true,
    },
    DOWNLOAD_CORRECTION_LOG: {
      actionTypeTag: "DOWNLOAD_CORRECTION_LOG",
      name: translate("reconciliation-runs.actions.DOWNLOAD_CORRECTION_LOG"),
      actionFN: (row) => {
        pollReconciliationFile(
          myStore,
          translate,
          "GetReconciliationFile",
          (data) => data.Files[FIRST_INDEX],
          (data, newPendingID) => {
            DownloadModalStore.open(MODAL_STORE_OPEN_TIMEOUT);
            DownloadModalStore.highlight(
              MODAL_STORE_HIGHLIGHT_TIMEOUT,
              newPendingID
            );
          },
          DOWNLOAD_CONFIGS.CORRECTION_LOG.domain,
          DOWNLOAD_CONFIGS.CORRECTION_LOG.type,
          "ReconciliationRunId",
          row.original.ReconciliationRunId.toString(),
          DOWNLOAD_CONFIGS.CORRECTION_LOG.label
        );
      },
      confirmationMessage: translate(
        "reconciliation-runs.confirmation-messages.DOWNLOAD_CORRECTION_LOG"
      ),
      confirmation: true,
    },
    ROLLBACK: {
      actionTypeTag: "ROLLBACK",
      name: translate("reconciliation-runs.actions.ROLLBACK"),
      actionFN: (row) => {
        RollbackReconciliationRun(
          row.original.ReconciliationRunId,
          (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.reload();
            });
          },
          myStore
        );
      },
      confirmationMessage: translate(
        "reconciliation-runs.confirmation-messages.ROLLBACK"
      ),
      confirmation: true,
    },
    VIEW_CORRECTION_LOG: {
      actionTypeTag: "VIEW_CORRECTION_LOG",
      name: translate("reconciliation-runs.actions.VIEW_CORRECTION_LOG"),
      actionFN: (row) => {
        pollReconciliationFile(
          myStore,
          translate,
          "GetReconciliationFile",
          (data) => data.Files[FIRST_INDEX],
          (data, newPendingID) => {
            DownloadModalStore.open(MODAL_STORE_OPEN_TIMEOUT);
            DownloadModalStore.highlight(
              MODAL_STORE_HIGHLIGHT_TIMEOUT,
              newPendingID
            );
          },
          DOWNLOAD_CONFIGS.CORRECTION_LOG.domain,
          DOWNLOAD_CONFIGS.CORRECTION_LOG.type,
          "ReconciliationRunId",
          row.original.ReconciliationRunId.toString(),
          DOWNLOAD_CONFIGS.CORRECTION_LOG.label
        );
      },
      confirmationMessage: translate(
        "reconciliation-runs.confirmation-messages.VIEW_CORRECTION_LOG"
      ),
      confirmation: true,
    },
  };
};
